export function debounce(func, delay) {
  let id;
  return function (...args) {
    const context = this;
    clearTimeout(id);
    id = setTimeout(() => func.apply(context, args), delay);
  };
}
